import React from 'react';
import { OperationSelectorProps } from '../utils/types';

const OperationSelector: React.FC<OperationSelectorProps> = ({
  onReset,
}) => {
  return (
    <div className="flex justify-center gap-4 mb-2">
      <button
        onClick={onReset}
        className="px-4 py-2 rounded-md transition-colors bg-blue-500 text-white"
      >
        Crop/Compress Image
      </button>
    </div>
  );
};

export default OperationSelector; 